import { DateTime } from '@ksyos/date-time';
import { getDisplayName } from '@common/utils/getDisplayName';
import { translateFinancialLogMutationReason } from '@common/utils/translateFinancialLogMutationReason';
import { formatMessage } from '@frontend/components/pages/processes/adminProcessFinancials/utils/formatMessage';
import type { FundingExclusion } from '../../adminProcessDetailsTypes';

export function formatFundingExclusion(fundingExclusion?: FundingExclusion) {
    if (!fundingExclusion) {
        return '';
    }

    const reason = fundingExclusion.reason ? translateFinancialLogMutationReason(fundingExclusion.reason) : null;
    const practitionerDisplayName = fundingExclusion.practitioner
        ? getDisplayName(fundingExclusion.practitioner)
        : null;

    const recordedDate = fundingExclusion.recordedDatetime
        ? DateTime.from(fundingExclusion.recordedDatetime).format('DD-MM-YYYY')
        : null;

    return formatMessage(reason, practitionerDisplayName, recordedDate);
}
